module.exports = __webpack_public_path__ + "static/media/hero.8d787ddb.jpg";